<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<router-link :to="{ name: 'kqgz_kqgz_gzb' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到工资表</el-button></router-link>
		<el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
			<el-table-column align="center" prop="id" width="50" label="编号"></el-table-column>
			<el-table-column align="center" label="关联工单" width="120" prop="gldd"></el-table-column>
			<el-table-column align="center" label="关联产品" width="200" prop="scdd.cpmc"></el-table-column>
			<el-table-column align="center" label="人员名称" width="140" prop="rymc"></el-table-column>
			<el-table-column align="center" label="工单价格" width="140" prop="scdd.gdje"></el-table-column>
			<el-table-column align="center" label="完成数量" width="140" prop="num"></el-table-column>
			<el-table-column align="center" label="绩效工资" width="140" prop="money"></el-table-column>
			<el-table-column align="center" label="创建时间" prop="create_time"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
export default {
	mixins: [common], // 引入mixins里的common.js
	data() {
		return {
			list:[],
			maxHeight: 0,
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
	},
	created(){
		
		this.getData(this.$route.params.data.id)
	},

	methods: {
		getData(e){
			this.axios.get('/admin/gzb/one/'+e,{
				token: true
			}).then(res => {
				this.list = res.data.data
			})
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
</style>
